import NavBar from "../../Navbar";
import "./JobDetail.css";
import React from "react";

function JobDetail() {
  return (
    <>
      <div className='NavBar'>
        <NavBar />
      </div>
      <div className='jobDetail'>
        <div className='leftSide'>
          <div className='jobContainer'>
            <div className='jobCard'>
              <div className='jobHeader'>
                <div className='jobHeaderContent'>Software Engineer</div>

                <div className='location'>Location</div>
              </div>
              <div className='companyName'>Leuwint</div>
              <div className='workLocation'>Remote </div>
              <div className='salary'>|</div>
              <div className='salary'>$ Not Disclosed</div>
              <div className='benfeits'>A list of benefits will be shown here along with the icons</div>
            </div>
          </div>
          <div className='descriptionContainer'>
            <div className='descriptionCard'>
              <div className='jobDescription'>
                <div>Job Description:</div>

                <div className='descriptionText'>
                  Lorem ipsum dolor sit amet. Non quia excepturi eum amet soluta ut dolorem quidem a vero natus ut culpa distinctio. At dolorum galisum qui dolor omnis ut
                  voluptatem cumque est harum harum. Qui quibusdam beatae vel accusamus quia quo internos voluptas vel provident quos At cupiditate rerum qui distinctio Quis! Qui
                  consectetur voluptatibus ea distinctio earum quo perspiciatis itaque eum nihil cumque. Aut itaque maxime ut porro ipsa et autem corrupti non quos labore ut neque
                  quibusdam. Eum dolores repellat sed ipsum cumque ut excepturi quia et galisum veniam 33 autem similique qui ratione neque! Aut tenetur quae quo rerum molestias ut
                  Quis tenetur aut eligendi voluptas. Sed assumenda reprehenderit aut voluptas voluptate aut velit reiciendis. Sed eveniet velit est autem reiciendis a placeat
                  earum ut galisum fugiat ut omnis pariatur id assumenda reiciendis. Quo consequuntur corrupti est repellendus nihil qui necessitatibus neque est iusto corrupti
                </div>
                <div className='otherDetails'>Other Details goes here</div>
              </div>
            </div>
          </div>
        </div>
        <div className='rightSide'></div>
      </div>
    </>
  );
}

export default JobDetail;
